(ns frontend.ui.component.lp-portal.strong-label.view
  (:require
   [frontend.ui.component.lp-portal.strong-label.style :as style]
   [herb.core :refer [<class]]))

(defn strong-label
  [label]
  [:div {:class (<class style/strong-label)}
   label])
